import React from "react";
import { Link } from "react-router-dom";
import TaxTools from "../../assets/TaxTools.png"

export default function TaxPreparation() {
    return (
        <>
        {/* Spacer for sticky header */}
            <div className="spacer spacer-30" />  {/* Header spacing style={{ height: 72 }}*/}

            {/* Hero section */}
            <section className="py-6 bg-white position-relative overflow-hidden">
                <div className="container">
                    <div className="row align-items-center gy-4">
                        {/* Text block */}
                        <div className="col-lg-6" data-aos="fade-right">
                            <h1
                                className="fw-bold mb-3"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: "#283870",
                                    fontSize: "2.8rem",
                                    lineHeight: 1.2,
                                }}
                            >
                                Tax Tools &amp; Resources
                            </h1>
                            <p
                                className="fs-5 text-secondary"
                                style={{ maxWidth: 520 }}
                            >
                                Your digital gateway to smarter tax preparation — calculators, forms, and trustworthy references for individuals and businesses.
                            </p>
                            <a  className="btn btn-primary btn-lg mt-4 shadow">
                                Explore Resources
                            </a>
                        </div>

                        {/* Image block */}
                        <div className="col-lg-6 text-center" data-aos="fade-left">
                            <img
                                src={TaxTools}
                                alt="Tax tools illustration"
                                className="img-fluid rounded shadow-lg"
                                style={{ maxHeight: 360, objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>

                {/* Decorative Circles (responsive classes) */}
                <div
                    aria-hidden="true"
                    className="position-absolute top-0 start-0 translate-middle rounded-circle bg-pink-400 opacity-25 decor-circle decor-180"
                    style={{ filter: "blur(50px)", zIndex: 0 }}
                ></div>
                <div
                    aria-hidden="true"
                    className="position-absolute bottom-0 end-0 translate-middle rounded-circle bg-violet-600 opacity-20 decor-circle decor-250"
                    style={{ filter: "blur(70px)", zIndex: 0 }}
                ></div>
            </section>


            {/* Resources Cards Section */}
            <section className="py-5" style={{ background: "#fff" }}>
                <div className="container">

                    <div className="mb-5">
                        <h3
                            className="fw-bold"
                            style={{
                                color: "#d53f8c",
                                fontFamily: "'Poppins',sans-serif",
                                fontSize: "1.5rem"
                            }}
                        >
                            Types of Individual Tax Returns
                        </h3>
                    </div>

                    <div className="row g-4">
                        {/* Tax Calculator */}
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center hover-resource">
                                <span
                                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-60"
                                    style={{ background: "#f2e6fa" }}
                                >
                                    <i className="bi bi-calculator fs-2" style={{ color: "#6B46C1" }}></i>
                                </span>
                                <h5 className="fw-semibold mb-2" style={{ color: "#6B46C1" }}>
                                    Tax Calculator
                                </h5>
                                <p className="mb-0" style={{ color: "#444" }}>
                                    Estimate your tax refund or liability with our easy-to-use calculator.
                                </p>
                            </div>
                        </div>

                        {/* Tax Forms and Publications */}
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center hover-resource">
                                <span
                                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-60"
                                    style={{ background: "#ddeefa" }}
                                >
                                    <i className="bi bi-file-earmark-text fs-2" style={{ color: "#2e3d9c" }}></i>
                                </span>
                                <h5 className="fw-semibold mb-2" style={{ color: "#224eae" }}>
                                    Tax Forms &amp; Publications
                                </h5>
                                <p className="mb-0" style={{ color: "#444" }}>
                                    Access IRS forms, instructions, and publications.
                                </p>
                            </div>
                        </div>

                        {/* Tax Glossary */}
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center hover-resource">
                                <span
                                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-60"
                                    style={{ background: "#e3e7f9" }}
                                >
                                    <i className="bi bi-book fs-2" style={{ color: "#D53F8C" }}></i>
                                </span>
                                <h5 className="fw-semibold mb-2" style={{ color: "#D53F8C" }}>
                                    Tax Glossary
                                </h5>
                                <p className="mb-0" style={{ color: "#444" }}>
                                    Understand key tax terms and definitions.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Optional: Quick action guide / next steps */}
                    <div className="row justify-content-center mt-5">
                        <div className="col-md-9 col-lg-8">
                            <div className="alert alert-info d-flex align-items-center p-4" style={{
                                background: "linear-gradient(90deg,#e3e7f9,#f6e6f8)",
                                border: "none"
                            }}>
                                <i className="bi bi-lightbulb-fill me-3" style={{ color: "#6B46C1", fontSize: 32 }}></i>
                                <div>
                                    <b style={{ color: "#2e3d9c" }}>Tip: </b>
                                    Start with our Tax Calculator or explore Forms and the Glossary to plan ahead and file taxes confidently.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            <section className="py-12 bg-gradient-to-r from-purple-700 to-pink-600 text-white text-center position-relative overflow-hidden">
                <div className="container max-w-3xl relative z-10">
                    <h2 className="display-4 fw-bold mb-4" style={{ fontFamily: "Poppins, sans-serif", color: "#15d6ddff" }}>
                        Need Expert Assistance?
                    </h2>
                    <p className="lead mb-5 opacity-85">
                        Connect with Nexen Consulting’s skilled tax professionals for personalized help with tax preparation,
                        tools, and resources — ensuring your filing is accurate, timely, and stress-free.
                    </p>
                </div>

                {/* Decorative blurred circles */}
                <div className="d-flex justify-content-center">
                    <Link
                        to="/contact"
                        className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
                        style={{
                            background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                            boxShadow: '0 4px 15px rgba(213, 63, 140, 0.6)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 30px rgba(213, 63, 140, 0.9)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(213, 63, 140, 0.6)';
                        }}
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>

            {/* Custom styles for resource card hover effect */}
            <style>{`
        .hover-resource {
          transition: box-shadow 0.27s, transform 0.21s;
        }
        .hover-resource:hover {
          box-shadow: 0 8px 30px #d53f8c33, 0 1.5px 6px #2e3d9c2a !important;
          transform: translateY(-6px) scale(1.025);
          z-index: 2;
        }
      `}</style>

            {/* Bootstrap Icons CDN (fallback if not imported globally) */}
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
            />


        </>
    );
}
